export default __webpack_public_path__ + "static/media/SevenX-Ventures.5412cbcf.svg";